module.exports = __webpack_public_path__ + "img/svea@2x.4af214f.png";